const mixedChart = {
    series: [{
        name: 'Absentee rate',
        type: 'area',
        data: [4.1, 3.8, 3.4, 3.6, 3, 2.7]
    }, {
        name: 'Absenteeism',
        type: 'line',
        data: [86, 80, 79, 78, 73, 66]
    }],
    chartOptions: {
        chart: {
            stacked: false,
            toolbar: {
                show: false
            }
        },
        stroke: {
            width: [0, 2, 4],
            curve: 'smooth'
        },
        plotOptions: {
            bar: {
                columnWidth: '50%'
            }
        },
        colors: ['#C0E79C', '#78BD9A'],
        fill: {
            opacity: [0.85, 0.25, 1],
            gradient: {
                inverseColors: false,
                shade: 'light',
                type: "vertical",
                opacityFrom: 0.85,
                opacityTo: 0.55,
                stops: [0, 100, 100, 100]
            }
        },
        labels: ['2015', '2016', '2017', '2018', '2019', '2020'],
        markers: {
            size: 0,
        },
        legend: {
            offsetY: 10,
        },
        xaxis: {
            type: 'datetime'
        },
        yaxis: [
            {
                title: {
                    text: 'Percentage',
                }
            },
            {
                opposite: true,
                title: {
                    text: "Days"
                }
            }
        ],
        tooltip: {
            shared: true,
            intersect: false,
        },
        grid: {
            borderColor: '#f1f1f1'
        }
    }
};

const linewithDataChart = {
    chartOptions: {
        chart: {
            zoom: {
                enabled: false
            },
            toolbar: {
                show: false
            }
        },
        colors: ['#78BD9A'],
        dataLabels: {
            enabled: true,
        },
        stroke: {
            width: [3, 3],
            curve: 'straight'
        },
        grid: {
            row: {
                colors: ['transparent', 'transparent'], // takes an array which will be repeated on columns
                opacity: 0.2
            },
            borderColor: '#f1f1f1'
        },
        markers: {
            style: 'inverted',
            size: 6
        },
        xaxis: {
            categories: ['2014', '2015', '2016', '2017', '2018', '2019', '2020'],
            title: {
                text: 'Year'
            }
        },
        yaxis: {
            title: {
                text: 'hours/employee'
            },
            min: 5,
            max: 40
        },
        responsive: [{
            breakpoint: 600,
            options: {
                chart: {
                    toolbar: {
                        show: false
                    }
                },
                legend: {
                    show: false
                },
            }
        }],
    },
    series: [{
        name: "average hours/employee",
        data: [26, 24, 32, 36, 33, 31, 33]
    },
    ],
};

export {linewithDataChart, mixedChart}